<div class="conteudo">
  <!-- <app-loading [exibir]="carregando"></app-loading> -->

  <!-- Cabeçalho moderno -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-text">
        <h1 class="page-title">
          <i class="fa fa-sitemap title-icon"></i>
          {{ 'parametros.tipoParada.titulo' | translate }}
        </h1>
        <p class="page-subtitle">{{ 'parametros.tipoParada.descricao' | translate }}</p>
      </div>
      <button type="button" class="btn-floating-add" (click)="display = true;"
        pTooltip="{{ 'parametros.tipoParada.adicionarTipoParada' | translate }}" tooltipPosition="left">
        <i class="fa fa-plus"></i>
        <span class="btn-label">{{ 'parametros.tipoParada.adicionarTipoParada' | translate }}</span>
      </button>
    </div>
  </div>

  <!-- Grid de tipos de evento -->
  <div class="tipo-eventos-grid" *ngIf="!carregando && tipoParadas.length > 0">
    <div class="tipo-evento-card" *ngFor="let tipoParada of tipoParadas; let i = index"
      [style.animation-delay]="(i * 0.1) + 's'">
      <div class="card-header-modern">
        <div class="tipo-evento-icon">
          <i class="fa fa-sitemap text-white"></i>
        </div>
        <div class="tipo-evento-info">
          <h3 class="tipo-evento-name">{{ tipoParada.nome }}</h3>
          <div class="tipo-evento-stats">
            <span class="stat-item">
              <i class="fa fa-link mr-1"></i>
              {{ tipoParada.vinculos }} {{ 'parametros.tipoParada.vinculos' | translate }}
            </span>
          </div>
        </div>
      </div>

      <div class="card-actions">
        <button type="button" class="btn-action btn-primary-action" (click)="verVinculos(tipoParada)"
          pTooltip="{{ 'parametros.tipoParada.verVinculos' | translate }}" tooltipPosition="top">
          <i class="fa fa-link"></i>
          <span>{{ 'parametros.tipoParada.gerenciar' | translate }}</span>
        </button>

        <button type="button" class="btn-action btn-danger-action" (click)="removerTipoParada(tipoParada.id)"
          pTooltip="{{ 'parametros.tipoParada.remover' | translate }}" tooltipPosition="top">
          <i class="fa fa-trash"></i>
          {{ 'parametros.tipoParada.excluir' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Estado vazio -->
  <div class="empty-state" *ngIf="!carregando && tipoParadas.length === 0">
    <div class="empty-state-content">
      <div class="empty-state-icon">
        <i class="fa fa-sitemap"></i>
      </div>
      <h3 class="empty-state-title">{{ 'parametros.tipoParada.nenhumTipoParada' | translate }}</h3>
      <p class="empty-state-description">{{ 'parametros.tipoParada.descricaoVazio' | translate }}</p>
      <button type="button" class="btn-empty-state" (click)="display = true">
        <i class="fa fa-plus mr-2"></i>
        {{ 'parametros.tipoParada.criarPrimeiroTipoParada' | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Modal para adicionar novo tipo de evento -->
<p-dialog [(visible)]="display" [modal]="true" [style]="{width: '40rem'}" [closable]="true" [draggable]="false"
  [styleClass]="'modern-dialog'">
  <ng-template pTemplate="header">
    <div class="modal-header-modern">
      <div class="modal-icon">
        <i class="fa fa-plus"></i>
      </div>
      <div class="modal-title-content">
        <h5 class="modal-title">
          {{ 'parametros.tipoParada.adicionarTipoParada' | translate }}
        </h5>
        <p class="modal-subtitle">{{ 'parametros.tipoParada.descricaoModal' | translate }}</p>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="body">
    <form #formTipoParada="ngForm" (ngSubmit)="adicionarTipoParada(nomeNovoTipoParada)" class="modern-form">
      <div class="form-group-modern">
        <label for="nomeTipoParada" class="form-label-modern">
          <i class="fa fa-sitemap label-icon"></i>
          {{ 'parametros.tipoParada.nomeTipoParada' | translate }} *
        </label>
        <div class="input-container">
          <input type="text" class="form-input-modern" id="nomeTipoParada" name="nomeTipoParada"
            [(ngModel)]="nomeNovoTipoParada" required maxlength="20"
            placeholder="{{ 'parametros.tipoParada.placeholderNome' | translate }}" autocomplete="off">
          <div class="input-border"></div>
        </div>
        <div class="error-message" *ngIf="formTipoParada.submitted && !nomeNovoTipoParada">
          <i class="fa fa-exclamation-circle"></i>
          {{ 'parametros.tipoParada.nomeObrigatorio' | translate }}
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="modal-footer-modern">
      <button type="button" class="btn-modal btn-cancel" (click)="display = false">
        <i class="fa fa-times"></i>
        {{ 'parametros.tipoParada.cancelar' | translate }}
      </button>
      <button type="button" class="btn-modal btn-save" (click)="adicionarTipoParada(nomeNovoTipoParada)">
        <i class="fa fa-save"></i>
        {{ 'parametros.tipoParada.salvar' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<!-- Modal para confirmar exclusão -->
<p-dialog [(visible)]="displayConfirmarExclusao" [modal]="true" [style]="{width: '35rem'}" [closable]="true"
  [draggable]="false" [styleClass]="'modern-dialog'">
  <ng-template pTemplate="header">
    <div class="modal-header-modern">
      <div class="modal-icon modal-icon-danger">
        <i class="fa fa-exclamation-triangle"></i>
      </div>
      <div class="modal-title-content">
        <h5 class="modal-title">
          {{ 'parametros.tipoParada.confirmarRemocao' | translate }}
        </h5>
        <p class="modal-subtitle">{{ 'parametros.tipoParada.confirmarRemocaoTexto' | translate }}</p>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="body">
    <div class="confirmation-content-simple">
      <div class="confirmation-text">
        <p class="confirmation-message">
          {{ 'parametros.tipoParada.confirmarRemocaoMensagem' | translate }}
        </p>
        <div class="tipo-evento-name-highlight">
          <i class="fa fa-sitemap"></i>
          <strong>{{ tipoParadaParaExcluir?.nome }}</strong>
        </div>
        <p class="confirmation-warning">
          {{ 'parametros.tipoParada.confirmarRemocaoDetalhes' | translate }}
        </p>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="modal-footer-modern">
      <button type="button" class="btn-modal btn-cancel" (click)="hideDialogConfirmarExclusao()">
        <i class="fa fa-times"></i>
        {{ 'parametros.tipoParada.cancelar' | translate }}
      </button>
      <button type="button" class="btn-modal btn-danger" (click)="confirmarExclusao()">
        <i class="fa fa-trash"></i>
        {{ 'parametros.tipoParada.confirmar' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<!-- Modal para gerenciar vínculos -->
<p-dialog [(visible)]="displayVinculos" [modal]="true" [style]="{width: '80rem'}" [closable]="true" [draggable]="false"
  [styleClass]="'modern-dialog modal-vinculos'">
  <ng-template pTemplate="header">
    <div class="modal-header-modern">
      <div class="modal-icon modal-icon-primary">
        <i class="fa fa-link"></i>
      </div>
      <div class="modal-title-content">
        <h5 class="modal-title">
          {{ 'parametros.tipoParada.gerenciarVinculos' | translate }}
        </h5>
        <p class="modal-subtitle">
          <i class="fa fa-sitemap mr-2"></i>
          {{ tipoParadaSelecionado?.nome }}
        </p>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="body">
    <!-- Loading moderno -->
    <div *ngIf="carregandoVinculos" class="loading-container">
      <div class="loading-content">
        <div class="loading-spinner">
          <div class="spinner-modern"></div>
        </div>
        <div class="loading-text">
          <h4>{{ 'parametros.tipoParada.carregandoVinculos' | translate }}</h4>
          <p>{{ 'parametros.tipoParada.aguarde' | translate }}</p>
        </div>
      </div>
    </div>

    <!-- Conteúdo do modal -->
    <div *ngIf="!carregandoVinculos" class="modal-content-container">
      <!-- Coluna esquerda - Elementos disponíveis -->
      <div class="modal-column">
        <div class="modal-card">
          <div class="modal-card-header">
            <div class="card-header-content">
              <div class="card-title-section">
                <div class="card-icon">
                  <i class="fa fa-list"></i>
                </div>
                <div class="card-title-text">
                  <h6 class="card-title">{{ 'parametros.tipoParada.elementosDisponiveis' | translate }}</h6>
                  <span class="card-count">{{ elementosDisponiveisFiltrados.length }}</span>
                </div>
              </div>
              <button type="button" class="btn-modern btn-modern-success" (click)="vincularTodosFiltrados()"
                [disabled]="elementosDisponiveisFiltrados.length === 0"
                pTooltip="{{ 'parametros.tipoParada.vincularTodos' | translate }}" tooltipPosition="top">
                <i class="fa fa-plus"></i>
                <span>{{ 'parametros.tipoParada.vincularTodos' | translate }}</span>
              </button>
            </div>
          </div>
          <!-- Barra de pesquisa moderna -->
          <div class="search-container">
            <div class="search-input-group">
              <div class="search-icon">
                <i class="fa fa-search"></i>
              </div>
              <input type="text" class="search-input" [(ngModel)]="termoPesquisaDisponiveis"
                (input)="filtrarElementosDisponiveis()"
                placeholder="{{ 'parametros.tipoParada.pesquisarElementos' | translate }}" autocomplete="off">
              <button class="search-clear" *ngIf="termoPesquisaDisponiveis" type="button"
                (click)="limparPesquisaDisponiveis()">
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
          <div class="modal-card-body">
            <div class="elements-list">
              <div class="element-item" *ngFor="let elemento of elementosDisponiveisFiltrados; trackBy: trackByElemento"
                (click)="adicionarVinculo(elemento)" [class.disabled]="elemento.vinculado">
                <div class="element-content">
                  <div class="element-icon">
                    <i class="fa fa-cube"></i>
                  </div>
                  <div class="element-info">
                    <span class="element-name">{{ elemento.nome }}</span>
                    <div class="tipo-evento-fabrica" *ngIf="elemento.contemFabrica">
                      <i class="fa fa-industry tipo-evento-fabrica-icon"></i>
                      <span class="tipo-evento-fabrica-text">Contém ID fábrica</span>
                    </div>
                    <span class="element-created-by" *ngIf="elemento.criadoPor">
                      {{ elemento.criadoPor }}
                    </span>
                  </div>
                  <div class="element-action">
                    <i class="fa fa-plus" *ngIf="!elemento.vinculado"></i>
                    <i class="fa fa-check" *ngIf="elemento.vinculado"></i>
                  </div>
                </div>
              </div>
              <div class="empty-state-list" *ngIf="elementosDisponiveisFiltrados.length === 0">
                <div class="empty-icon">
                  <i class="fa fa-search"></i>
                </div>
                <p class="empty-text">{{ 'parametros.tipoParada.nenhumElementoEncontrado' | translate }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Coluna direita - Elementos vinculados -->
      <div class="modal-column">
        <div class="modal-card">
          <div class="modal-card-header">
            <div class="card-header-content">
              <div class="card-title-section">
                <div class="card-icon card-icon-linked">
                  <i class="fa fa-link"></i>
                </div>
                <div class="card-title-text">
                  <h6 class="card-title">{{ 'parametros.tipoParada.elementosVinculados' | translate }}</h6>
                  <span class="card-count card-count-linked">{{ elementosVinculados.length }}</span>
                </div>
              </div>
              <button type="button" class="btn-modern btn-modern-danger" (click)="removerTodosVinculos()"
                [disabled]="elementosVinculados.length === 0"
                pTooltip="{{ 'parametros.tipoParada.removerTodos' | translate }}" tooltipPosition="top">
                <i class="fa fa-times"></i>
                <span>{{ 'parametros.tipoParada.removerTodos' | translate }}</span>
              </button>
            </div>
          </div>
          <!-- Barra de pesquisa moderna -->
          <div class="search-container">
            <div class="search-input-group">
              <div class="search-icon">
                <i class="fa fa-search"></i>
              </div>
              <input type="text" class="search-input" [(ngModel)]="termoPesquisaVinculados"
                (input)="filtrarElementosVinculados()"
                placeholder="{{ 'parametros.tipoParada.pesquisarElementos' | translate }}" autocomplete="off">
              <button class="search-clear" *ngIf="termoPesquisaVinculados" type="button"
                (click)="limparPesquisaVinculados()">
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
          <div class="modal-card-body">
            <div class="elements-list">
              <div class="element-item element-item-linked"
                *ngFor="let elemento of elementosVinculadosFiltrados; trackBy: trackByElemento"
                (click)="removerVinculo(elemento)">
                <div class="element-content">
                  <div class="element-icon element-icon-linked">
                    <i class="fa fa-link"></i>
                  </div>
                  <div class="element-info">
                    <span class="element-name">{{ elemento.nome }}</span>
                    <div class="tipo-evento-fabrica" *ngIf="elemento.contemFabrica">
                      <i class="fa fa-industry tipo-evento-fabrica-icon"></i>
                      <span class="tipo-evento-fabrica-text">Contém ID fábrica</span>
                    </div>
                    <span class="element-created-by" *ngIf="elemento.criadoPor">
                      {{ elemento.criadoPor }}
                    </span>
                  </div>
                  <div class="element-action element-action-remove">
                    <i class="fa fa-times"></i>
                  </div>
                </div>
              </div>
              <div class="empty-state-list" *ngIf="elementosVinculados.length === 0">
                <div class="empty-icon">
                  <i class="fa fa-info-circle"></i>
                </div>
                <p class="empty-text">{{ 'parametros.tipoParada.nenhumVinculo' | translate }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="modal-footer-modern">
      <button type="button" class="btn-modal btn-cancel" (click)="hideDialogVinculos()">
        <i class="fa fa-times"></i>
        {{ 'parametros.tipoParada.fechar' | translate }}
      </button>
      <button type="button" class="btn-modal btn-save" (click)="salvarVinculos()" [disabled]="!alteracoesVinculos">
        <i class="fa fa-save"></i>
        {{ 'parametros.tipoParada.salvarAlteracoes' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>